import { render, staticRenderFns } from "./cus-info-form.vue?vue&type=template&id=7d552a18&scoped=true"
import script from "./cus-info-form.vue?vue&type=script&lang=js"
export * from "./cus-info-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d552a18",
  null
  
)

export default component.exports